<template>
    <!-- ### BRANCHES TOWARDS COLUMN -->
    <WithoutShiftBranchesTowardsColumn v-if="!branchDirectionTowardRow"
        :student-counts="studentCounts"
        :branches="branches"
        :classes="classes"
        :class-wise="classWise"
        :branch-wise="branchWise"
        :section-wise="sectionWise"
        :type="type"
    />

    <!-- ### CLASSES TOWARDS COLUMN -->
    <WithoutShiftBranchesTowardsRow v-else
        :student-counts="studentCounts"
        :branches="branches"
        :classes="classes"
        :class-wise="classWise"
        :branch-wise="branchWise"
        :section-wise="sectionWise"
        :type="type"
    />

  <!-- Percentage -->
  <tr v-if="type !== 'total'">
    <td v-if="branchDirectionTowardRow && branchWise || !branchDirectionTowardRow && classWise">
      Percentage
    </td>
    <td v-if="!branchDirectionTowardRow && branchWise" v-for="branch in branches">
      <SectionWiseCount
            :session="session"
          :student-counts="studentCounts"
          :filter="{branch_id: branch.id}"
          :section="null"
          :is-total="false"
          :is-percentage="true"
          :section-wise="sectionWise"
      />
    </td>
    <td v-else-if="branchDirectionTowardRow && classWise" v-for="clazz in classes">
      <SectionWiseCount
            :session="session"
          :student-counts="studentCounts"
          :filter="{class_id: clazz.id}"
          :section="null"
          :is-total="false"
          :is-percentage="true"
          :section-wise="sectionWise"
          :type="type"
      />
    </td>
    <td v-else>
      <SectionWiseCount
            :session="session"
          :student-counts="studentCounts"
          :filter="{}"
          :section="null"
          :is-total="false"
          :is-percentage="true"
          :section-wise="sectionWise"
      />
    </td>
    <td v-if="branchDirectionTowardRow && classWise || !branchDirectionTowardRow && branchWise"> </td>
  </tr>
</template>

<script>
import {Collection} from "collect.js";
import SectionWiseCount from "./SectionWiseCount.vue";
import WithoutShiftBranchesTowardsColumn from "./WithoutShiftBranchesTowardsColumn.vue";
import WithoutShiftBranchesTowardsRow from "./WithoutShiftBranchesTowardsRow.vue";

export default {
  components: {WithoutShiftBranchesTowardsRow, WithoutShiftBranchesTowardsColumn, SectionWiseCount},
  props: {
    type: String,
    session: Number,
    studentCounts: Collection,
    branches: Collection,
    classes: Collection,
    shifts: Collection,
    classWise: Boolean,
    branchWise: Boolean,
    sectionWise: Boolean,
    branchDirectionTowardRow: Boolean,
  },
}
</script>

<style scoped>
.table th div{
  padding: 0.5rem;
}
</style>